export default __webpack_public_path__ + "static/media/Hargrove Decatur Cube 1.98b0fd10.jpg";